import { Box, BoxProps, createStyles } from '@mantine/core';
import React from 'react';

const useStyles = createStyles((_theme, size: any) => ({
  box: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  prePriceWrapper: {
    display: 'flex',
    alignItems: { sm: 'center' }[size] || 'end',
    gap: { sm: '0px' }[size] || 10,
    flexDirection: { sm: 'column' }[size] || 'row',
  },
  preText: {
    position: 'relative',
    fontSize: { sm: 11 }[size] || 16,
    top: { md: -3, lg: -5 }[size] || 'auto',
  },
  priceText: {
    fontSize: { md: 28, lg: 38 }[size] || 22,
    fontWeight: 700,
  },
  postText: {
    fontSize: 11,
    alignSelf: { sm: 'center' }[size] || 'end',
  },
}));

const Price = (
  props: {
    size?: 'sm' | 'md' | 'lg';
    preText?: React.ReactNode;
    postText?: React.ReactNode;
    children?: React.ReactNode;
  } & BoxProps = { size: 'sm' },
) => {
  const { size, preText, postText, children, ...rest } = props;
  const { classes } = useStyles(size);
  return (
    <Box {...rest} className={classes.box}>
      <Box className={classes.prePriceWrapper}>
        {preText && <Box className={classes.preText}>{preText}</Box>}
        <Box c="primary" className={classes.priceText}>
          {children}
        </Box>
      </Box>
      {postText && <Box className={classes.postText}>{postText}</Box>}
    </Box>
  );
};

export default Price;
